import { Component, Input } from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "app-star-with-number",
  templateUrl: "./star-with-number.component.html",
  styleUrls: ["./star-with-number.component.scss"],
  standalone: true,
  imports: [AngularSvgIconModule],
})
export class StarWithNumberComponent {
  /** Path to the thumb icon (e.g. the yellow star or the cloud). */
  @Input() icon: string = "assets/icons/icon-star-yellow.svg";
  /** Value rendered centred on top of the icon. */
  @Input() number: number | string = "";
  @Input() numberColor: string = "var(--color-evergreen)";
  /** Number font size, in rem. */
  @Input() numberSize: number = 1.125;
  /** Icon (and overall) size, in rem. */
  @Input() iconSize: number = 2.25;
  @Input() fontWeight: string = "700";
}
